import { Component, Input, OnInit, inject, input, output, viewChild } from '@angular/core';
import {BreakpointsDetectorService} from '../../../services/breakpoints-detector.service';
import {UserService} from '../../../services/user/user.service';
import {EnvironmentService} from '../../../services/environment.service';
import {ModalService} from '../../../modal/modal.service';
import {LanguageService} from '../../../services/language.service';
import {JackpotService, JackpotLevelsPlace} from '../../../../page/jackpot/jackpot.service';
import {PlatformService} from '../../../services/platform.service';
import {AccordionDirective} from "../../directives/accordion.directive";
import { TranslatePipe } from '../../../services/translation/translate.pipe';
import { RadialProgressComponent } from '../radial-progress/radial-progress.component';
import { SliderComponent } from '../slider/slider.component';
import { ClassLoadedDirective } from '../../directives/class-loaded.directive';
import { RouterLinkDirective } from '../../directives/router-link.directive';
import { RouterLink } from '@angular/router';
import { BtnComponent } from '../btn/btn.component';
import { OdometerComponent } from '../../../modules/odometer/odometer.component';
import { AppShellNoSSRDirective } from '../../directives/appshell/app-shell-no-ssr.directive';
import { TextGradientComponent } from '../text-gradient/text-gradient.component';
import { NgClass, NgTemplateOutlet, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-jackpot-levels',
    templateUrl: './jackpot-levels.component.html',
    styleUrls: ['./jackpot-levels.component.scss'],
    imports: [NgClass, TextGradientComponent, AppShellNoSSRDirective, OdometerComponent, BtnComponent, RouterLink, RouterLinkDirective, ClassLoadedDirective, NgTemplateOutlet, SliderComponent, RadialProgressComponent, AccordionDirective, AsyncPipe, TranslatePipe]
})
export class JackpotLevelsComponent implements OnInit {
  jackpot = inject(JackpotService);
  breakpoint = inject(BreakpointsDetectorService);
  user = inject(UserService);
  env = inject(EnvironmentService);
  lang = inject(LanguageService);
  private _modal = inject(ModalService);
  private _platform = inject(PlatformService);


  /**
   * Input value for change view levels
   */
  @Input() place: any = JackpotLevelsPlace.JACKPOT;

  /**
   * Input value for special in game view
   */
  readonly isGame = input<boolean>(false);

  readonly accordionHeader = viewChild('accordionHeader', { read: AccordionDirective });

  readonly isJackpotOpen$ = output<boolean>({ alias: 'isJackpotOpen' });

  public hideJackpotValue: boolean;

  public isOpened = false;

  public sliderLevelsConfig = {
    loop: true,
    centered: false,
    slides: {
      spacing: 10
    },
    breakpoints: {
      '(max-width: 768px)': {
        slides: {
          perView: 1.1,
          spacing: 10,
        },
      },
    },
  };

  public levelsPlace = JackpotLevelsPlace;

  ngOnInit() {
  }

  /**
   * Open rules modal
   */
  public async openRulesModal() {
    if (!this._platform.isBrowser)  {
      return;
    }

    if (this.place === this.levelsPlace.GAME || this.place === this.levelsPlace.GAME_LIST) {
      const component = await import('../../../modal/components/lazy/jackpot-rules/jackpot-rules.component');
      await this._modal.openLazy(
        component?.JackpotRulesComponent,
        {
        template: 'CLEAR'
      });
    }
  }

  toggle() {
    this.isOpened = !this.isOpened;
  }

  openAccordion() {
    const accordionHeader = this.accordionHeader();
    this.isJackpotOpen$.emit(!accordionHeader.isOpen);
    this.isJackpotOpen$.emit(!accordionHeader.isOpen);
  }
}
